export default __webpack_public_path__ + "static/media/blur-1630.845c366d.png";